/** Spanish for one part of the app (ADR 0325); see index.ts for the house style. */
export const phone: Readonly<Record<string, string>> = {
  // The Phone screen and its three tabs (ADR 0310)
  Phone: "Teléfono",
  Messages: "Mensajes",
  Recents: "Recientes",
  Voicemail: "Buzón de voz",
  "Unknown number": "Número desconocido",
  "No texts yet.": "Aún no hay mensajes.",
  Conversations: "Conversaciones",
  Unanswered: "Sin responder",
  "Conversation with {name}": "Conversación con {name}",
  "Not on a job yet": "Aún sin trabajo",
  "Open job →": "Abrir trabajo →",
  "Open contact →": "Abrir contacto →",
  "This customer has no job yet, so there is nowhere to reply from here. Open the contact and add one.":
    "Este cliente aún no tiene trabajo, así que no hay desde dónde responder aquí. Abrir el contacto y agregar uno.",
  "Nobody in Roof Board has this number. It is in New Leads on the pipeline until somebody makes it a lead.":
    "Nadie en Roof Board tiene este número. Está en Nuevos prospectos en el embudo hasta que alguien lo convierta en prospecto.",

  // Recents and Voicemail
  "No voicemails.": "No hay mensajes de voz.",
  "No calls yet.": "Aún no hay llamadas.",
  Voicemails: "Mensajes de voz",
  "Recent calls": "Llamadas recientes",
  // The word beside a call (recentsLabel in packages/core)
  Outgoing: "Saliente",
  Incoming: "Entrante",
  Missed: "Perdida",
  "No answer": "Sin respuesta",
  Calling: "Llamando",
  "new caller": "número nuevo",
  Play: "Reproducir",
  "Hide transcript": "Ocultar transcripción",
  "Read transcript": "Ver transcripción",
  "Could not be transcribed: {error}": "No se pudo transcribir: {error}",
  "Being transcribed…": "Transcribiendo…",
  "Reading…": "Leyendo…",
  "Read it again": "Volver a leer",

  // The Call button
  Call: "Llamar",
  "Call {number}": "Llamar {number}",
  "Call from your phone": "Llamar desde este teléfono",
  "Call through Roof Board: your phone rings, then the customer is connected":
    "Llamar por Roof Board: suena este teléfono y luego se conecta al cliente",
  "Ringing you…": "Timbrando…",
  "Your phone will ring from the Roof Board line. Answer it and you will be connected.":
    "El teléfono sonará desde la línea de Roof Board. Al contestar, se conecta la llamada.",

  // The Messages screen: who is waiting on a reply (ADR 0227)
  "Unknown sender": "Remitente desconocido",
  "Loading…": "Cargando…",
  "{waiting} waiting on us · {replied} replied · {noReply} need no reply":
    "{waiting} esperan respuesta · {replied} respondidos · {noReply} sin necesidad de respuesta",
  "Nobody is waiting on a reply from the last 14 days.":
    "Nadie espera respuesta de los últimos 14 días.",
  "Waiting on us": "Esperan respuesta",
  "Probably no reply needed": "Probablemente no necesita respuesta",
  "Same day": "Mismo día",
  "Waiting {n} min": "Esperando {n} min",
  "Waiting {n} hr": "Esperando {n} h",
  "Waiting {n} hrs": "Esperando {n} h",
  "Waiting {n} day": "Esperando {n} día",
  "Waiting {n} days": "Esperando {n} días",
  "1 attachment": "1 adjunto",
  "{n} attachments": "{n} adjuntos",
  "(no text)": "(sin texto)",
  Email: "Email",
  Text: "Mensaje de texto",
  "Full conversation →": "Conversación completa →",
  "Marking…": "Marcando…",
  "Mark handled": "Marcar como atendido",
  "Not on a job yet, so there is nowhere to reply from here.":
    "Aún sin trabajo, así que no hay desde dónde responder aquí.",
};
